import { ChangeDetectionStrategy, Component, EnvironmentInjector, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SessionTimeoutDialogComponent } from '@reza-ais-fe/ui/components';
import { MetaService, PageSettingsModule } from '@shared/modules/page-settings';
import { LoadingOverlayComponent, RouterOutletComponent } from '@shared/ui/components';
import {
  DEFAULT_NOTIFICATION_SLOT_KEY,
  ERROR_NOTIFICATION_SLOT_KEY,
  RouteParamsService,
  setAppEnvironmentInjector,
  UIService,
} from '@shared/utils';
import { Optimus } from '@openng/optimus-ui/config';
import { TimesCircleIcon } from '@openng/optimus-ui/icons/timescircle';
import { ToastModule } from '@openng/optimus-ui/toast';
import { CommonModule } from '@angular/common';
import PrimeNgTranslation from './PrimeNgTranslation';
@Component({
  selector: 'reza-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutletComponent,
    CommonModule,
    RouterModule,
    PageSettingsModule,
    ToastModule,
    TimesCircleIcon,
    LoadingOverlayComponent,
    SessionTimeoutDialogComponent,
  ],
})
export class AppComponent {
  private _meta = inject(MetaService);
  private _config = inject(Optimus);
  private _uiService = inject(UIService);
  private _routeParamsService = inject(RouteParamsService);

  ERROR_NOTIFICATION_SLOT_KEY = ERROR_NOTIFICATION_SLOT_KEY;
  DEFAULT_NOTIFICATION_SLOT_KEY = DEFAULT_NOTIFICATION_SLOT_KEY;

  loading$ = this._uiService.loading$;

  constructor() {
    const injector = inject(EnvironmentInjector);

    this._meta.init();

    this._routeParamsService.init();

    this._config.setTranslation(PrimeNgTranslation);

    setAppEnvironmentInjector(injector);
  }
}
